import { observer } from 'mobx-react';
import React, { Component, ReactElement } from 'react';
import { withRouter } from 'react-router';
import Loader from '../../components/Loader/Loader';
import { LoaderManagerStore } from '../../stores';
import { LoaderManagerStoreModel } from '../../stores/loaderManagerStore/loaderManagerStoreModel';
import styles from './WithLoadingData.module.scss';
import { WithLoadingDataProps, WithLoadingDataState } from './WithLoadingDataModel';


@observer
class WithLoadingData extends Component<WithLoadingDataProps, WithLoadingDataState> {
    loaderManagerStore: LoaderManagerStoreModel;

    constructor(props: WithLoadingDataProps) {
        super(props);

        this.loaderManagerStore = new LoaderManagerStore();
    }

    componentDidUpdate(prevProps: WithLoadingDataProps) {
        if (((prevProps.location.search !== this.props.location.search) ||
            (prevProps.location.pathname !== this.props.location.pathname))
            && this.props.rerenderWhenRouteChange
        ) {
            this.executeApiCall(prevProps);
        }
    }

    componentDidMount() {
        this.executeApiCall();
    }

    componentWillUnmount() {
        this.loaderManagerStore = new LoaderManagerStore();
    }

    async executeApiCall(prevProps?: WithLoadingDataProps, currentProps?: WithLoadingDataProps) {
        this.loaderManagerStore.setLoader();
        await this.props.promise(prevProps);
        if (this.loaderManagerStore) { this.loaderManagerStore.unsetLoader(); }
    }

    render() {
        if (this.props.broadcastLoading && Array.isArray(this.props.children)) {
            throw new Error('With broadcastLoading childrenProps must be a single JSX.ELEMENT');
        }
        if (this.props.broadcastLoading) {
            return (
                React.cloneElement(
                    this.props.children as ReactElement<any>,
                    { isLoading: this.loaderManagerStore.showLoader }
                ));
        }
        if (this.loaderManagerStore.mustShowLoader) {
            return (<Loader className={styles.CenteredLoader} />);
        }
        return this.props.children;
    }
}

export default withRouter(WithLoadingData);
